import React from 'react';
import Button from '../button/Button';
import './verticalNavigation.scss';

interface VerticalNavigationItem {
    label: string;
    icon: string;
    onClick?: () => void;
}

interface VerticalNavigationProps {
    items: VerticalNavigationItem[];
    initialIndex?: number;
    onChange?: (index: number) => void;
}

function VerticalNavigation({items, initialIndex = 0, onChange}: VerticalNavigationProps): JSX.Element {
    return (
        <div className="c-verticalNavigation">
            {items.map((item, index) => (
                <Button
                    className="c-verticalNavigation__item"
                    key={item.label}
                    variant={index === initialIndex ? 'solid' : 'ghost'}
                    leading={item.icon}
                    color="primary"
                    onClick={() => {
                        onChange && onChange(index);
                        item.onClick && item.onClick();
                    }}
                    type="button"
                >
                    {item.label}
                </Button>
            ))}
        </div>
    );
}

export default VerticalNavigation;
